var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square-30 flex-center cursor-pointer rounded-8 bg-white shadow shrink-0",on:{"click":_vm.onBack}},[_c('van-icon',{attrs:{"name":"arrow-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }